import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentApprovedWarm(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#document-approved-warm_svg__a)"
        strokeWidth={10}
        d="M50 26.333C50 18.97 55.97 13 63.333 13h49.334C120.03 13 126 18.97 126 26.333v67.334c0 7.363-5.97 13.333-13.333 13.333H63.333C55.97 107 50 101.03 50 93.667z"
      />
      <path stroke="#0D2B57" d="M67 34.5h42m-42 10h42" />
      <rect width={39} height={39} x={106.5} y={54.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={106.5} y={54.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m120.167 75.25 3.5 3.75 8.166-10"
      />
      <defs>
        <linearGradient
          id="document-approved-warm_svg__a"
          x1={88}
          x2={88}
          y1={13}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentApprovedWarm);
export default ForwardRef;
